<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()" *ngIf="!setupMode">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      <ng-container *ngIf="setupMode">{{ 'ACCOUNT.lbl.setup_wedding_couple' | translate }}</ng-container>
      <ng-container *ngIf="!setupMode">{{ 'LIST.role.wedding_couple' | translate }}</ng-container>
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <ion-list class="background-transparent" lines="none" *ngIf="accountCoupleList?.length">
    <div class="ion-margin-vertical" *ngIf="!setupMode">
      <ion-item-divider color="light">
        <ion-text class="font-12">{{ 'WEDDING_COUPLE.name' | translate }}</ion-text>
      </ion-item-divider>
      <ng-container *ngFor="let accountCouple of accountCoupleList;">
        <ng-container *ngIf="accountCouple?.coupleType">
          <ng-container  *ngIf="coupleNameList?.[accountCouple?.coupleId] else emptyBlock">
            <ion-item (click)="presentCoupleNamePrompt(accountCouple, coupleNameList?.[accountCouple?.coupleId])" detail>
              <ion-label class="font-12" color="medium">{{ 'LIST.wedding_couple_type.' + accountCouple.coupleType | translate }}<span *ngIf="sameCoupleType"> {{ accountCouple.coupleId }}</span></ion-label>
              <ion-text class="font-14 font-med" color="dark" slot="end">{{ coupleNameList?.[accountCouple?.coupleId] }}</ion-text>
            </ion-item>
          </ng-container>
          <ng-template #emptyBlock>
            <ion-item (click)="presentCoupleNamePrompt(accountCouple, '')" detail>
              <ion-label class="font-12" color="medium">{{ 'LIST.wedding_couple_type.' + accountCouple.coupleType | translate }}<span *ngIf="sameCoupleType"> {{ accountCouple.coupleId }}</span></ion-label>
            </ion-item>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>

    <ion-item-divider color="light">
      <ion-text class="font-12">{{ 'WEDDING_COUPLE.access' | translate }}</ion-text>
    </ion-item-divider>
    <app-account-couple-item class="full-width-height" [ready]="ready"></app-account-couple-item>
  </ion-list>
</ion-content>
<ion-footer>
  <ion-toolbar class="ion-no-padding">
    <div class="ion-padding-vertical">
      <app-account-couple-type class="full-width full-height" [saveMode]="true" [footer]="true" [setReady]="true"></app-account-couple-type>
    </div>
    <ion-button class="ion-margin" expand="block" color="primary" fill="solid" type="button" (click)="dismissModal()" *ngIf="setupMode">
      {{ 'BTN.next' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>